import { callApi, HTTPMethods } from '@/utils/api';
import KeycloakService from '@/services/keycloakService';
import { UseStoreUser } from '@/store/userStore';
import { UserApp } from '@/types/user';
// @ts-ignore
import SrhUiI18nService from 'srh-ui/dist/services/i18n';
import { TypeNotification, useGlobalStore } from '@/store/globalStore';
import { getApiUrl } from '@/utils/url';

export default {
  /** Fetches user apps from GET users/:userId/apps (products use fixed display values, no translation). */
  async loadUserApps(
    userId: string | undefined,
    onSuccess?: (apps: UserApp[]) => void,
    onError?: () => void
  ) {
    const i18n = new SrhUiI18nService();
    const { t } = i18n.getI18nInstance().global;
    const globalStore = useGlobalStore();

    if (!userId?.trim()) {
      if (onError) onError();
      return;
    }

    try {
      await KeycloakService.CallUpdate().then(async () => {
        const config = {
          'Content-Type': 'application/json',
        };
        const path = `${getApiUrl()}/users/${userId}/apps`;
        await callApi({
          method: HTTPMethods.GET,
          path,
          options: config,
          body: {},
          successCallback: (result: UserApp[]) => {
            if (onSuccess) onSuccess(result);
          },
          errorMessage: t('errors.habs'),
        });
      });
    } catch (e) {
      globalStore.showNotification(
        TypeNotification.ERROR,
        t('errors.habs'),
        t('errors.title')
      );
      if (onError) onError();
    }
  },

  /** Reads resource_access directly from the Keycloak token and stores it as user roles. */
  loadUserRolesFromToken() {
    const userStore = UseStoreUser();
    const resourceAccess =
      KeycloakService.currentInstance.tokenParsed?.resource_access;
    if (resourceAccess) {
      userStore.setUserRoles(resourceAccess);
    }
  },
};
